import { GameState } from "../../../core/protocol/types";
import type {
  MultiplayerOverlayState,
  MultiplayerPhase,
} from "./MultiplayerPhaseTypes";

interface PhaseMapInput {
  gameState: GameState | null;
  runtimeReady: boolean;
  countdownNumber: number | null;
}

interface PhaseMapResult {
  phase: MultiplayerPhase;
  overlay: MultiplayerOverlayState;
}

const DEFAULT_LOADING_OVERLAY: MultiplayerOverlayState = {
  type: "loading",
  message: "Preparing runtime…",
};

export function mapPhaseState({
  gameState,
  runtimeReady,
  countdownNumber,
}: PhaseMapInput): PhaseMapResult {
  if (!runtimeReady || !gameState) {
    return { phase: "loading", overlay: DEFAULT_LOADING_OVERLAY };
  }

  if (!gameState.localConnectionId) {
    return { phase: "spectate", overlay: { type: null } };
  }

  const countdownActive = countdownNumber !== null;
  const sync = gameState.roundSyncState;

  let phase: MultiplayerPhase;

  if (gameState.status === "finished") {
    phase = "finished";
  } else if (gameState.status === "active") {
    phase = "active";
  } else if (countdownActive) {
    phase = "countdown";
  } else if (sync === "last" && gameState.status === "waiting") {
    phase = "lobby";
  } else if (sync === "waitForWinner" || sync === "waitForRestart") {
    phase = "lobby";
  } else if (sync === "last") {
    phase = "finished";
  } else {
    // status === "waiting" or anything else defaults to lobby
    phase = "lobby";
  }

  const overlay: MultiplayerOverlayState = mapOverlay(phase, countdownNumber);
  return { phase, overlay };
}

function mapOverlay(
  phase: MultiplayerPhase,
  countdownNumber: number | null
): MultiplayerOverlayState {
  switch (phase) {
    case "loading":
      return DEFAULT_LOADING_OVERLAY;
    case "lobby":
      return { type: "lobby" };
    case "countdown":
      return { type: "countdown", countdownNumber: countdownNumber ?? undefined };
    case "finished":
      return { type: "results" };
    default:
      return { type: null };
  }
}

